/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Contract_Revoke_ActionInputs */



/**
* | output |
* | --- |
* | "Withdraw approval" |
*
* @param {Partner_Org_Contract_Revoke_ActionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_revoke_action = /** @type {((inputs?: Partner_Org_Contract_Revoke_ActionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Revoke_ActionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Freigabe zurückziehen")
	return /** @type {LocalizedString} */ ("Withdraw approval")
});